export const coverageLineStyles = Object.freeze(
  /** @type {const} */ ({
    SINGLE: 'SINGLE',
    MULTI_LABEL: 'MULTI_LABEL',
    HEADER_TEXT: 'HEADER_TEXT',
    INDICATORS_ONLY: 'INDICATORS_ONLY',
    NO_DESCRIPTORS: 'NO_DESCRIPTORS',
  })
);
